import { render, staticRenderFns } from "./VTh.vue?vue&type=template&id=10bf588a&scoped=true&"
import script from "./VTh.vue?vue&type=script&lang=js&"
export * from "./VTh.vue?vue&type=script&lang=js&"
import style0 from "./VTh.vue?vue&type=style&index=0&id=10bf588a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf588a",
  null
  
)

export default component.exports